export default __webpack_public_path__ + "static/media/blog3.d195267c.png";